import { createSlice } from '@reduxjs/toolkit'
import { RentabilityInitialState } from '@/modules/settings/tasa/types/types.ts'

const initialState: RentabilityInitialState = {
  openCreateModal: false,
  selected: null
}

const rentabilitySlice = createSlice({
  name: 'rentabilities',
  initialState,
  reducers: {
    selectRentability(state, action) {
      state.selected = action.payload
    },
    cleanSelection(state) {
      state.selected = null
    },
    openModal: (state) => {
      state.openCreateModal = true
    },
    closeModal: (state) => {
      state.openCreateModal = false
    }
  }
})

export const rentabilitiesActions = rentabilitySlice.actions

export const { reducer: rentabilitiesReducer } = rentabilitySlice
